module.exports = __webpack_public_path__ + "img/calendar.edaaf0f4.png";